module.exports = __webpack_public_path__ + "img/BE_BC_Front@2x.faef95cb.png";